import {StyleSheet, TouchableOpacity, Image, ViewStyle, StyleProp, TextStyle} from "react-native";
import React from "react";
import Text from '../../common/component/CustomTextComponent';
import { THEME_COLORS } from '../themes';

interface ICustomButtonProps {
  disabled?: boolean;
  onPress?: () => void;
  text: string | JSX.Element;
  iconFileNameInAssets?: string;
  iconWidth?: number;
  iconHeight?: number;
  textColor?: string;
  disableButtonStyle?: boolean;
  testID?: string;
  style?: StyleProp<ViewStyle>;
  backgroundColor?: string;
  textStyle?: StyleProp<TextStyle>;
  childrenComp?: any;
}

export const CustomButton = (props: ICustomButtonProps) => {
    const isDisabled = props.disabled;
    const iconFileName = props.iconFileNameInAssets;
    const iconHeight = props.iconHeight;
    const iconWidth = props.iconWidth;
    const style = props.style;
    const textColor = !!props.textColor ? props.textColor : "#fff";
    const disableButtonStyle = !!props.disableButtonStyle && props.disableButtonStyle;
    return <TouchableOpacity
        testID={props.testID}
        style={
            [styles.actionButton,{ width: 'fit-content', // PLATFORM:WEB
         }, style,
                {
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                    minWidth: 100
                },
                !disableButtonStyle ? {
                    backgroundColor: isDisabled ? '#d6d6d6' : (props.backgroundColor ? props.backgroundColor :THEME_COLORS.primaryPurple),
                    // shadowColor: 'rgba(0,0,0,0.6)',
                    // shadowRadius: 5,
                } : { borderRadius: 0 }
            ]}
        onPress={props.onPress}
        disabled={isDisabled}
    >
        {props.childrenComp ? props.childrenComp : null}
        {iconFileName ? <Image source={require('../../assets/' + iconFileName)}
                               style={{width: iconWidth, height: iconHeight, marginRight: 5}}/> : null}
        <Text
            style={[styles.actionButtonText, styles.headText, {color: isDisabled ? "#000" : textColor}, props.textStyle]}>
            {props.text}</Text>
    </TouchableOpacity>
}

const styles = StyleSheet.create({
    headText: {
        color: '#200E36',
        // fontWeight: 'bold',
        fontFamily: 'FuturaPTDemi',
    },
    actionButton: {
        // backgroundColor: "#5100AD",
        borderRadius: 10,
        paddingHorizontal: 12,
        paddingVertical: 8,
        height: 25
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    actionButtonText: {
        color: '#fff'
    },
})